const dateFormatter = (dateString, enableSharing = false) => {
  if (!dateString) return;
  if (!enableSharing) {
    const monthMap = {
      Agu: 'Ags',
    };
    // Remove time parts
    const justDate = dateString?.slice(0, 10);

    // Parsing date to array
    const dateParts = justDate?.split('-');

    // Convert date to MM-DD-YYYY as a valid JavaScript format
    const dateObject = new Date(+dateParts?.[2], dateParts?.[1] - 1, +dateParts?.[0]);

    // Formatting date to display
    const formatter = new Intl.DateTimeFormat('id-ID', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
    const parts = formatter.formatToParts(dateObject);
    const formattedDate = parts
      .map((part) => {
        if (part.type === 'month') {
          return monthMap[part.value] || part.value;
        }
        return part.value;
      })
      .join('');
    return formattedDate;
  } else {
    //Use for CMS Format 2023-10-15T05:00:00.000Z
    const inputDate = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: '2-digit' };
    return inputDate?.toLocaleDateString('id-ID', options);
  }
};

export const dateFormatterEmarsys = (date: string) => {
  const dateArray = date?.split('-');
  if (!dateArray || dateArray.length < 3) return '';
  const temp = dateArray[0];
  dateArray[0] = dateArray[1];
  dateArray[1] = temp;
  const inputDate = new Date(dateArray.join('-'));
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: '2-digit' };
  return inputDate?.toLocaleDateString('id-ID', options);
};

export const dateFormatterEmarsysReverseMonthDate = (date: string) => {
  if (!date) return;
  // Remove time parts
  const justDate = date?.slice(0, 10);

  // Parsing date to array
  const dateParts = justDate?.split('-');

  // Convert date to MM-DD-YYYY as a valid JavaScript format
  const dateObject = new Date(+dateParts?.[2], +dateParts?.[1] - 1, +dateParts?.[0]);

  // Formatting date to display
  const formattedDate = new Intl.DateTimeFormat('id-ID', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })?.format(dateObject);

  return formattedDate;
};

export default dateFormatter;
